import { render, staticRenderFns } from "./DeleteRepairTypeUser.vue?vue&type=template&id=260340eb"
import script from "./DeleteRepairTypeUser.vue?vue&type=script&lang=js"
export * from "./DeleteRepairTypeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports